export enum AugloopKeys {
    SessionUrl = "SessionUrl",
    SessionGuid = "SessionGuid",
    ServiceUrl = "ServiceUrl",
    InitializeAugloopRuntimeManagerDuration = "InitializeAugloopRuntimeManagerDuration"
};